/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_MonthInputs */

const en_shared_month = /** @type {(inputs: Shared_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`month`)
};

const de_shared_month = /** @type {(inputs: Shared_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monat`)
};

const es_shared_month = /** @type {(inputs: Shared_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mes`)
};

const fr_shared_month = /** @type {(inputs: Shared_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mois`)
};

/** @type {(inputs: Shared_MonthInputs) => LocalizedString} */
const it_shared_month = en_shared_month;

/** @type {(inputs: Shared_MonthInputs) => LocalizedString} */
const pt_br2_shared_month = en_shared_month;

/** @type {(inputs: Shared_MonthInputs) => LocalizedString} */
const pl_shared_month = en_shared_month;

/** @type {(inputs: Shared_MonthInputs) => LocalizedString} */
const hu_shared_month = en_shared_month;

/** @type {(inputs: Shared_MonthInputs) => LocalizedString} */
const ro_shared_month = en_shared_month;

/**
* | output |
* | --- |
* | "month" |
*
* @param {Shared_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_month = /** @type {((inputs?: Shared_MonthInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_MonthInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_month(inputs)
	if (locale === "de") return de_shared_month(inputs)
	if (locale === "es") return es_shared_month(inputs)
	if (locale === "fr") return fr_shared_month(inputs)
	if (locale === "it") return it_shared_month(inputs)
	if (locale === "pt-BR") return pt_br2_shared_month(inputs)
	if (locale === "pl") return pl_shared_month(inputs)
	if (locale === "hu") return hu_shared_month(inputs)
	return ro_shared_month(inputs)
});
export { shared_month as "shared.month" }